
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Dashboard from '@/components/Dashboard.vue';
import { TemplateReportList } from '@/collections/template_reports';
import { MeasureList } from '@/collections/measures';
import { StoreModel } from '@/models/store';
import MenuVersionModule from '@/store/modules/menu-version';
import store from '@/store';
import { homeLandingPath } from '@/views/homeTodayRedirect';

@Component({
  components: {
    Dashboard,
  },
})
export default class SystemDashboard extends Vue {
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  @Prop({ default: false })
  public enableAthena!: boolean;
  @Prop({ default: false })
  public isDataReady!: boolean;
  @Prop({ default: false })
  public isAthenaReady!: boolean;
  @Prop({ default: false })
  public isAthenaFinished!: boolean;
  @Prop({ default: () => [] })
  public timeRangeLimit!: string[];
  @Prop({ default: 'available' })
  public isLockedReports!: string;
  @Prop({ default: false })
  public hasSchemas!: boolean;
  @Prop({ default: () => new TemplateReportList() })
  public templateReports!: TemplateReportList;
  @Prop({ default: () => new MeasureList() })
  public measures!: MeasureList;
  public dashboardId: number = 0;
  public dashboardType: string = '';
  private menuVersionStore = getModule(MenuVersionModule, store);

  public get menuVersion() {
    return this.menuVersionStore.menuVersion;
  }

  public async created() {
    if (this.store.config.homepageDashboardId) {
      this.dashboardId = this.store.config.homepageDashboardId;
      this.dashboardType = this.store.config.homepageDashboardType;
    } else {
      this.dashboardId = 117;
      this.dashboardType = 'PUBLIC';
    }
  }

  // Redirect v3 stores (menu-version rollout) straight to the Today agent
  // once onboarding is complete. Three watchers cover the async orderings of
  // "menuVersion resolves" vs "real store data lands" vs "onboarding finishes
  // on the same store object": VerticalMenuBar re-resolves menuVersion on
  // `store.id` change (see VerticalMenuBar.vue:888 onStoreChange ->
  // resolveMenuVersionFromStore), via an async chain, so either the Vuex
  // commit or the store prop update can land first; `passedInstallingFlow`
  // flips separately via updateInstallationStatus() without `store.id`
  // changing. All watchers call the same idempotent check; the guard on
  // `$route.name === 'home'` makes re-firing after the first replace() a
  // no-op.
  @Watch('menuVersion', { immediate: true })
  @Watch('store.id')
  @Watch('store.passedInstallingFlow')
  @Watch('store.currentPackage.name')
  @Watch('isAthenaFinished')
  public onMenuVersionOrStoreChanged() {
    const landing = homeLandingPath({
      menuVersion: this.menuVersion,
      storeId: this.store ? this.store.id : null,
      passedInstallingFlow: this.store ? this.store.passedInstallingFlow : undefined,
      routeName: this.$route.name,
      packageName: this.store ? this.store.currentPackage?.name : null,
      isAthenaFinished: this.isAthenaFinished,
    });
    if (landing) {
      this.$router.replace(landing).catch(() => {});
    }
  }
}
